import {BikStoreState} from '@/modules/deals/services/store/bikStore/BikStoreState';

const state: BikStoreState = {
  BikReports: [],
  selectedBikReportId: undefined,
};

export const BikStoreModule = {
  namespaced: false,
  state,
};
